import isEmpty from "lodash/isEmpty";
import type { Element, Node } from "React";
import { Component } from "react";
import { EventHelper } from "../../../../../../../../../../../helpers/eventHelper";
import AsianOdds from "../../../../../../../../../../../screens/AsianEventsScreen/components/AsianOdds/AsianOdds";
import type { EventType } from "../../../../../../../../../../../types/eventType";
type Props = {
  event: EventType;
  runner: Record<string, any>;
}; //

class RenderOddsComponent extends Component<Props> {
  render(): Node | Element<"div"> {
    const { event, runner } = this.props;
    const aggregatedPrices = runner["aggregatedPrices"];

    if (!isEmpty(aggregatedPrices)) {
      const highestOdds = EventHelper.getHighestOddsValueFrom(aggregatedPrices);
      return (
        <AsianOdds
          className={event["inRunning"] ? "asian-odds-live" : ""}
          odds={highestOdds}
          key={"asian-odds" + runner.id}
          runner={runner}
        />
      );
    } else
      return (
        <div>
          <span className="blank__runner">&nbsp;</span>
        </div>
      );
  }
}

export default RenderOddsComponent;
